<template lang="pug">
	.control-actions-section
		a.link.prev(:href="prev" rel="prev" v-if="prev")
			span.arrow-left
			span Previous

		a.link(v-for="(page, index) in pages" :href="page.url" :class="{ 'current-page': trimmedUrl(page.url) == currentUrl}")
			span.page-number
				| {{page.index}}

		a.link.next(:href="next" rel="next" v-if="next")
			span Next
			span.arrow-right
</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'

.sticky
	position sticky
	top 60px

.control-actions-section
	text-align center
	margin-top 60px
	margin-bottom 30px
	clear both
	text-align center
	margin-top 60px
	margin-bottom 30px
	clear both
	&.slideshow
		a.link.next
			position relative
			top -3px
		a.link.next
		a.link.prev
			width auto!important
			span.arrow-left
				display inline-block
				left -6px
				position relative
				top 1px
				border-right 7px solid #000
			span.arrow-right
				display: inline-block
				right: -6px
				position: relative
				top: 3px
				border-left: 7px solid #000


	a.link
		padding: 15px
		display: inline-block
		border: 1px solid sfc-pale-gray
		transition-all()
		text-decoration: none
		border-radius: 5px
		margin: 7.5px
		width: 50px
		height: 50px
		color: body-font-color
		box-shadow-dd()

		span.page-number
			display: block
			text-align: center
		&.current-page
			border: 1px solid sfc-blue-border
			background: sfc-blue
			color: #fff
			&:hover
				color: #fff
				background: sfc-blue-hover
				border 1px solid sfc-blue-border
		&:hover
			background: #fff
			border: 1px solid sfc-blue
			span.arrow-left
				border-right: 7px solid #000
		&.next
		&.prev
			width: 125px
			span.arrow-left
				display: inline-block
				left: -10px
				position: relative
				top: 1px
				border-right: 7px solid #000
			span.arrow-right
				display: inline-block
				right: -10px
				position: relative
				top: 1px
				border-left: 7px solid #000
			&.disabled
				color sfc-pale-gray!important
				border 1px solid sfc-pale-gray!important
				cursor default
				span.arrow-left
					border-right 7px solid sfc-pale-gray
				span.arrow-right
					border-left 7px solid sfc-pale-gray
				&hover
					color sfc-pale-gray!important
					border 1px solid sfc-pale-gray!important
					span.arrow-left
						border-right 7px solid sfc-pale-gray
					span.arrow-right
						border-left 7px solid sfc-pale-gray
		&.prev
			padding-left 25px
			margin-left 0px
		&.next
			padding-right 25px
			margin-right 0px




</style>


<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service.js"
	export default {

		props: ['toc', 'sticky'],

		mounted(){
		},

		data(){
			let currentIndex = this.toc.findIndex((page) => page.url.replace(/\/$/, "") == this.$route.path.replace(/\/$/, ""))

			let pages = []
			let prev = false
			let next = false

			if (this.toc[currentIndex -1]) {
				this.toc[currentIndex -1].index = currentIndex
				pages.push(this.toc[currentIndex -1])
				prev = this.toc[currentIndex -1].url
			}

			this.toc[currentIndex].index = currentIndex + 1
			pages.push(this.toc[currentIndex])

			if (this.toc[currentIndex + 1]) {
				this.toc[currentIndex + 1].index = currentIndex + 2
				pages.push(this.toc[currentIndex + 1])
				next = this.toc[currentIndex +1].url
			}

			return {
				pages,
				currentIndex,
				prev,
				next
			}
		},

		computed: {
			currentUrl(){
				return this.$route.path.replace(/\/$/, "")
			}
		},

		methods:{
			trimmedUrl(url){
				return url.replace(/\/$/, "")
			}
		}

	}
</script>
